// @ts-nocheck
import translate from "@insite/client-framework/Translate";

/**
 * Construct the plural keyword for a unit of measure.
 */
export const uomPluralKeyword = (uom: string): string => `${uom}_plural`;

/**
 * Translate the specified keyword, falling back to the given fallback
 */
const translateWithFallback = (keyword: string, fallback: string): string => {
    // eslint-disable-next-line spire/avoid-dynamic-translate
    const keywordTranslation = translate(keyword);
    return keywordTranslation === keyword ? fallback : keywordTranslation;
};

/**
 * Return the plural label for a UoM:
 *  • if a plural translation exists, return it;
 *  • otherwise return the raw UoM code.
 */
export const getUoMPluralKeywordTranslation = (uom: string): string =>
    translateWithFallback(uomPluralKeyword(uom), uom);

/**
 * Format a UoM displayed translation based on quantity:
 */
export const formatUoMTranslation = (uom: string, qty: number): string => {
    if (qty !== 1) {
        return translateWithFallback(uomPluralKeyword(uom), uom);
    }
    return translateWithFallback(uom, uom);
};

export default formatUoMTranslation;
